import { siteName } from './site';

export const legalConfig = {
  businessName: siteName,
  privacyEmail: 'privacy@rentalmanagement.com',
  supportEmail: 'support@elsehaven.com',
  supportPhone: '',
  mailingAddress: '',
  lastUpdated: '2025-12-26',
  sellsPersonalInfo: false,
  sharesPersonalInfo: false,
  dataCategories: [
    {
      category: 'Identifiers',
      examples: 'Name, email address, phone number.',
    },
    {
      category: 'Booking details',
      examples: 'Stay dates, guest counts, property preferences.',
    },
    {
      category: 'Customer support',
      examples: 'Messages and special requests.',
    },
    {
      category: 'Internet activity',
      examples: 'Usage data if analytics is enabled.',
    },
  ],
  purposes: [
    'Provide and manage bookings.',
    'Communicate about stays, changes, and support requests.',
    'Secure the platform and prevent fraud.',
    'Improve our services and user experience.',
  ],
  sources: [
    'Directly from you when you create a booking or contact support.',
    'Automatically from your browser or device when you use the site.',
  ],
  disclosures: [
    'Hosting and infrastructure providers.',
    'Communication tools (email/SMS) used to deliver booking updates.',
    'Payment processors when payment collection is enabled.',
  ],
  retention:
    'We keep personal information as long as needed to fulfill bookings, comply with legal obligations, or resolve disputes.',
};

export const ccpaRequestTypes = [
  { value: 'ACCESS', label: 'Access my data' },
  { value: 'DELETE', label: 'Delete my data' },
  { value: 'CORRECT', label: 'Correct my data' },
  { value: 'OPT_OUT', label: 'Opt out of sale/sharing' },
];
